// botActions.js
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/config";
// import { useRoomsStore } from "../store/useRoomsStore"; // ✅ grab the hook
import {
  savePlayerDeckAndHand,
  updateHandAndDeck,
} from "../utils/roomFunctions";
import { parseCardEffect } from "./deckEngine";
import _ from "lodash";
import { specialtyCardEffect } from "../utils/Utils";

// const { hands, decks } = useRoomsStore.getState();

export const getBotDelay = () => Math.floor(Math.random() * 5000) + 5000;
export const getRandomItem = (arr) =>
  arr[Math.floor(Math.random() * arr?.length)];
export const delay = (ms) => new Promise((res) => setTimeout(res, ms));
export const getNextLivingPlayerIndex = (players, currentIndex) => {
  console.warn("Players", players.length, "Current INdex", currentIndex);
  const total = players?.length;
  let i = currentIndex;

  for (let count = 0; count < total; count++) {
    i = (i + 1) % total;
    const candidate = players[i];
    if (!candidate.character.isDead) {
      return i;
    }
  }

  // fallback (shouldn't happen)
  return currentIndex;
};

export const stripHandAndDeckFromPlayers = (players) => {
  return [...players].map(({ hand, deck, ...rest }) => ({ ...rest }));
};

const reassignWeight = (
  actions,
  bot,
  hand,
  matchData,
  lastMoveWasStanceChange = false
) => {
  const character = bot.character;
  const updatedActions = [...actions];
  const health = character.health;
  const stance = character.stance;
  const hasDefense = character.defense > 0;

  const healingCard = hand.find(
    (card) =>
      card.affectedAreas?.includes("health") && card.turnsActive === "Instant"
  );

  const buffCard = hand.find((card) =>
    card.affectedAreas?.some((area) =>
      ["attack", "defense", "accuracy"].includes(area.toLowerCase())
    )
  );

  const lowHealth = health <= 3;
  const highHealth = health >= 6;

  // Reset weights
  updatedActions.forEach((a) => (a.weight = 25));

  // 🛡️ Can't attack if in defense
  if (stance === "defense") {
    const attackAction = updatedActions.find((a) => a.type === "attack");
    if (attackAction) attackAction.weight = 0;
  }

  // 🧠 Don't attack if you *just* attacked
  const lastMove = matchData?.moves?.at(-1);
  const didJustAttack =
    lastMove?.player === bot.name && lastMove.type.includes("attack");

  if (didJustAttack) {
    const attackAction = updatedActions.find((a) => a.type === "attack");
    if (attackAction) attackAction.weight = 0;
  }

  // ⚠️ LOW HEALTH MODE (somewhat defensive)
  if (lowHealth) {
    if (stance === "attack" && hasDefense && !lastMoveWasStanceChange) {
      updatedActions.find((a) => a.type === "stance").weight += 10;
    }
    if (healingCard) {
      updatedActions.find((a) => a.type === "playCard").weight += 15;
    } else {
      updatedActions.find((a) => a.type === "tradeCard").weight += 5;
    }
  }

  // 💪 HIGH HEALTH MODE
  if (highHealth) {
    if (stance === "defense" && !lastMoveWasStanceChange) {
      updatedActions.find((a) => a.type === "stance").weight += 20;
    }
    if (stance === "attack") {
      if (!lastMoveWasStanceChange)
        updatedActions.find((a) => a.type === "stance").weight = 0;
      const attackAction = updatedActions.find((a) => a.type === "attack");
      if (attackAction) attackAction.weight += 20;
    }
  }

  // 🧠 Already in attack stance? Favor attacking
  if (stance === "attack") {
    updatedActions.find((a) => a.type === "attack").weight += 20;
    updatedActions.find((a) => a.type === "playCard").weight += buffCard
      ? 10
      : 0;
  }

  // 🧃 No healing or buffs? Trade it up
  if (!healingCard && !buffCard) {
    updatedActions.find((a) => a.type === "tradeCard").weight += 5;
  }

  return updatedActions;
};

// const reassignWeight = (
//   actions,
//   bot,
//   hand,
//   matchData,
//   lastMoveWasStanceChange = false,
//   nextPlayer = null,
//   isPVE = false
// ) => {
//   let updatedActions = [...actions];
//   const stance = bot.character.stance;
//   const health = bot.character.health;
//   const defense = bot.character.defense;
//   const accuracy = bot.character.accuracy;

//   let healingCard
//   let buffAccuracyCard
//   let buffDefenseCard

//   const hasTradeableCards =
//     hand.length >= 3 && !healingCard && !buffAccuracyCard && !buffDefenseCard;

//   const lowHealth = health <= 4;
//   const highHealth = health >= 6;
//   const lowAccuracy = accuracy <= 4;
//   const inDefense = stance === "defense";
//   const inAttack = stance === "attack";

//   // 🔁 Reset all weights
//   updatedActions.forEach((a) => (a.weight = 25));

//   // ❌ Rule 1: Don’t change stance if already changed this turn
//   if (lastMoveWasStanceChange) {
//     updatedActions.find((a) => a.type === "stance").weight = 0;
//   }

//   // ❤️ Rule 2: Low Health + Heal Card → Heal
//   if (lowHealth && healingCard) {
//     updatedActions.find((a) => a.type === "playCard").weight += 30;
//   }

//   // 🛡️ Rule 3: Low Health + Has Defense → Heal or Buff Defense
//   if (lowHealth && defense > 0) {
//     if (!inDefense)
//       updatedActions.find((a) => a.type === "stance").weight += 15;
//     if (buffDefenseCard)
//       updatedActions.find((a) => a.type === "playCard").weight += 20;
//     if (healingCard)
//       updatedActions.find((a) => a.type === "playCard").weight += 20;
//   }

//   // 🎯 Rule 4: Low Accuracy → Boost It
//   if (lowAccuracy && buffAccuracyCard) {
//     updatedActions.find((a) => a.type === "playCard").weight += 25;
//   }

//   // ❌ Rule 5: Cannot Attack in Defense Stance
//   const attackAction = updatedActions.find((a) => a.type === "attack");
//   if (inDefense && attackAction) {
//     attackAction.weight = 0;
//   }

//   // 🧨 NEW: Add affliction card preference if in attack stance
//   if (afflictionCard && inAttack) {
//     updatedActions.find((a) => a.type === "playCard").weight += 15;
//   }

//   // 🗡️ Rule 6: Attack Weak Enemies (no defense)
//   const enemyNoDefense = matchData.players?.some(
//     (p) => p.id !== bot.id && !p.character.isDead && p.character.defense === 0
//   );
//   if (inAttack && enemyNoDefense && attackAction) {
//     attackAction.weight += 25;
//   }

//   // ☠️ Rule 7: If any enemy can be killed, prioritize attack
//   const killableEnemy = matchData.players?.find(
//     (p) =>
//       p.id !== bot.id &&
//       !p.character.isDead &&
//       p.character.health + p.character.defense <= bot.character.attack
//   );
//   if (killableEnemy && attackAction) {
//     attackAction.weight += 30;
//   }

//   // 🛡️ Rule 8: High health, no defense → Buff up
//   if (highHealth && defense === 0) {
//     if (buffDefenseCard)
//       updatedActions.find((a) => a.type === "playCard").weight += 20;
//     if (!inDefense)
//       updatedActions.find((a) => a.type === "stance").weight += 15;
//   }

//   // 🔥 Rule 9: High health + high accuracy in defense → go aggressive
//   if (highHealth && accuracy >= 6 && inDefense) {
//     updatedActions.find((a) => a.type === "stance").weight += 10;
//   }

//   // 🧠 Rule 10: Prep for next player
//   if (nextPlayer?.character) {
//     const nextIsThreat =
//       nextPlayer.character.attack >= 5 && nextPlayer.character.accuracy >= 6;

//     if (nextIsThreat && defense < 3) {
//       updatedActions.find((a) => a.type === "stance").weight += 10;
//       if (buffDefenseCard)
//         updatedActions.find((a) => a.type === "playCard").weight += 10;
//     }
//   }

//   // 🤝 Rule 11: PVE + bot is next → Attack more
//   if (isPVE && nextPlayer?.isBot && attackAction) {
//     attackAction.weight += 10;
//   }

//   // ♻️ Rule 12: Trade junk
//   if (hasTradeableCards) {
//     updatedActions.find((a) => a.type === "tradeCard").weight += 20;
//   }

//   return updatedActions;
// };

export const simulateBotTurn = async (
  botPlayer,
  allPlayers,
  matchData,
  roomId,
  syncMatchData,
  initDelay = true,
  //   nextTurn,
  hands,
  decks,
  hasStartedBotTurnRef
) => {
  console.log("🤖 Bot is thinking (from simulateBotTurn function)...");
  const matchRef = doc(db, "rooms", roomId, "matchData", "match");

  //   console.warn("ALL PLAYERS", allPlayers);

  if (!allPlayers || !botPlayer || !hands[botPlayer.id] || !matchData) {
    return;
  }

  let currentPlayerIndex = -1;

  const MIN_THINKING_TIME = 5000;
  const thinkStart = Date.now();

  try {
    // let playersCopy = [...allPlayers];
    let playersCopy = allPlayers.map((p) => _.cloneDeep(p)); //! Testing

    currentPlayerIndex = playersCopy.findIndex((p) => p.id === botPlayer.id);
    if (currentPlayerIndex === -1) {
      console.warn("🚨 Bot not found in playersCopy:", botPlayer.name);
      return;
    }

    // Don't double-wait if initDelay already handled it
    if (initDelay) {
      await delay(MIN_THINKING_TIME);
    } else {
      const elapsed = Date.now() - thinkStart;
      const remaining = MIN_THINKING_TIME - elapsed;
      if (remaining > 0) await delay(remaining);
    }

    console.log("after the delay");

    const refreshedSnap = await getDoc(matchRef);
    const refreshedData = refreshedSnap.data();
    matchData = refreshedData;
    playersCopy = refreshedData?.players?.map((p) => _.cloneDeep(p));
    let bot = playersCopy.find((p) => p.id === botPlayer.id); // safer

    let hand = Array.isArray(hands?.[bot.id]) ? hands[bot.id] : [];
    const deck = Array.isArray(decks?.[bot.id]) ? decks[bot.id] : [];

    // console.log("Current index => ", currentPlayerIndex);
    // console.log(bot.name);

    //   const cpMovesLeft = latestData?.cpMovesLeft;
    const currentPlayer = refreshedData?.currentPlayerTurn;

    if (currentPlayer !== currentPlayerIndex) return;

    let actions = [
      { type: "attack", weight: 25 },
      { type: "stance", weight: 25 },
      { type: "playCard", weight: 25 },
      { type: "tradeCard", weight: 25 },
    ];

    const lastMove = refreshedData?.moves?.at(-1);
    let lastMoveWasStanceChange =
      lastMove?.type === "stanceChange" && lastMove?.player === bot?.name;
    let nextPlayer = getNextLivingPlayerIndex(playersCopy, currentPlayerIndex);
    let isPVE = refreshedData?.pve;

    let newlyWeightedActions = reassignWeight(
      actions,
      bot,
      hand,
      refreshedData,
      lastMoveWasStanceChange
      //   nextPlayer,
      //   isPVE
    );

    if (lastMoveWasStanceChange) {
      newlyWeightedActions.find((a) => a.type === "stance").weight = 0;
      if (bot.character.stance === "attack" && bot.character.defense === 0) {
        newlyWeightedActions.find((a) => a.type === "stance").weight = 0;
      }
      if (bot.character.stance === "defense") {
        newlyWeightedActions.find((a) => a.type === "playCard").weight += 15;
      }
    }

    const totalWeight = newlyWeightedActions.reduce(
      (sum, a) => sum + a.weight,
      0
    );
    const weightedChoice = Math.random() * totalWeight;

    let runningSum = 0;
    const selectedAction = actions.find((action) => {
      runningSum += action.weight;
      return weightedChoice <= runningSum;
    });

    console.log("Bot is about to take action =>", selectedAction.type);

    let actionSucceeded = false;

    switch (selectedAction.type) {
      case "attack": {
        const enemies = matchData?.pve
          ? allPlayers.filter(
              (p) => p.id !== bot.id && !p.character.isDead && !p.isBot
            )
          : allPlayers.filter((p) => p.id !== bot.id && !p.character.isDead);
        console.warn("BEFORE RANDOM ITEM SELECTION =>", enemies);
        const target = getRandomItem(enemies);
        if (target && bot.character.stance === "attack") {
          actionSucceeded = true;
          await simulateBotAttack(
            bot,
            target,
            playersCopy,
            syncMatchData,
            matchRef
          );
        } else {
          // console.log("⚠️ Bot is not in attack stance, can't attack.");
        }
        break;
      }

      case "stance": {
        const botIndex = playersCopy.findIndex((p) => p.id === bot.id);
        let updatedBot = { ...bot };

        updatedBot.character.stance =
          updatedBot.character.stance === "attack" ? "defense" : "attack";

        playersCopy[botIndex] = updatedBot;

        actionSucceeded = true;

        const move = {
          type: "stanceChange",
          player: bot.name,
          newStance: updatedBot.character.stance,
          timestamp: Date.now(),
        };

        console.log("👉 playersCopy before stance:", playersCopy);
        let updatedPlayersCopy = stripHandAndDeckFromPlayers(playersCopy);
        console.log("👉 Updated playersCopy after trade:", updatedPlayersCopy);

        await syncMatchData(bot.id, updatedPlayersCopy, move);
        await delay(500);
        break;
      }

      case "playCard": {
        let success = false;
        const maxAttempts = 3;
        let attemptCount = 0;

        while (!success && attemptCount < maxAttempts) {
          const playableCard = hand.find((card) =>
            card.affectedAreas?.some((area) =>
              ["health", "attack", "accuracy", "defense"].includes(
                area.toLowerCase()
              )
            )
          );

          if (playableCard) {
            actionSucceeded = true;
            console.warn(
              "BEFORE RANDOM ITEM SELECTION PLAY CARD =>",
              allPlayers,
              "IS PVE =>",
              isPVE
            );

            let target = null;

            let cardData = parseCardEffect(playableCard);
            if (cardData.isAid) {
              if (isPVE) {
                target = getRandomItem(
                  allPlayers.filter(
                    (p) => p.id === bot.id || (!p.character.isDead && p.isBot)
                  )
                );
              } else {
                target = allPlayers.find((p) => p.id === bot.id);
              }
            } else {
              if (isPVE) {
                target = getRandomItem(
                  allPlayers.filter(
                    (p) => p.id !== bot.id && !p.character.isDead && !p.isBot
                  )
                );
              } else {
                target = allPlayers.find((p) => p.id !== bot.id);
              }
            }

            if (target) {
              await simulateBotPlayCard(
                roomId,
                bot,
                playersCopy,
                playableCard,
                syncMatchData,
                target,
                matchRef,
                hands,
                decks
              );
              success = true;
            }
          }

          attemptCount++;
        }

        // ✅ Default to random card play if nothing else worked
        if (!success) {
          console.warn("RETRY PLAY CARD =>", hand, isPVE);
          console.warn("RETRY PLAY CARD =>", allPlayers);
          const randomCard = getRandomItem(hand);
          let fallbackTarget;

          let cardData = parseCardEffect(randomCard);
          if (cardData.isAid) {
            if (isPVE) {
              fallbackTarget = getRandomItem(
                allPlayers.filter(
                  (p) => p.id === bot.id || (!p.character.isDead && p.isBot)
                )
              );
            } else {
              fallbackTarget = allPlayers.find((p) => p.id === bot.id);
            }
          } else {
            if (isPVE) {
              fallbackTarget = getRandomItem(
                allPlayers.filter(
                  (p) => p.id !== bot.id && !p.character.isDead && !p.isBot
                )
              );
            } else {
              fallbackTarget = allPlayers.find((p) => p.id !== bot.id);
            }
          }

          if (randomCard && fallbackTarget) {
            await simulateBotPlayCard(
              roomId,
              bot,
              playersCopy,
              randomCard,
              syncMatchData,
              fallbackTarget,
              matchRef,
              hands,
              decks
            );
            //   console.log("🔄 Defaulting to random card play.");
          }
        }

        break;
      }

      case "tradeCard": {
        const enemies = allPlayers.filter(
          (p) => p.id !== bot.id && !p.character.isDead
        );
        // console.warn("BEFORE RANDOM ITEM SELECTION PLAY CARD =>", enemies);
        // console.warn("BEFORE RANDOM ITEM SELECTION PLAY CARD =>", allPlayers);
        const target = getRandomItem(enemies);
        const cardToTrade = getRandomItem(hand);
        //   console.log("CARD TO TRADE", cardToTrade);

        console.warn("Trading with => ", target?.name);
        console.warn("Card to Trade", cardToTrade);

        let tradeSuccess = false;

        if (target && cardToTrade) {
          actionSucceeded = true;

          tradeSuccess = await simulateBotTradeCard(
            roomId,
            bot,
            target,
            playersCopy,
            cardToTrade,
            syncMatchData,
            hands,
            decks
          );
        }

        if (!tradeSuccess) {
          // console.log("♻️ Bot fallback: trade failed, rerolling...");
          const otherActions = actions.filter((a) => a.type !== "tradeCard");
          console.warn(
            "BEFORE RANDOM ITEM SELECTION PLAY CARD =>",
            otherActions
          );
          const rerolled = getRandomItem(otherActions);
          selectedAction.type = rerolled.type;
        }

        break;
      }

      default:
        break;
    }

    if (actionSucceeded) {
      console.log("⏳ Waiting for move commit to settle...");
      await delay(1500);
    }
  } catch (error) {
    console.error("Error in botAction:", error);
  }
};

export const simulateBotAttack = async (
  bot,
  target,
  playersCopy,
  syncMatchData,
  matchRef
) => {
  const botIndex = playersCopy.findIndex((p) => p.id === bot.id);
  const targetIndex = playersCopy.findIndex((p) => p.id === target.id);

  const attacker = { ...bot };
  const defender = { ...target };
  console.log("🛡️ DEFENDER IN ATTACK MOVE =>", defender);

  const accuracy = attacker.character.accuracy;
  const attack = attacker.character.attack;

  const roll = Math.ceil(Math.random() * 10);
  let totalDamage = 0;
  let critical = false;

  if (accuracy >= roll) {
    totalDamage = attack;
    if (accuracy === roll) {
      totalDamage += 1;
      critical = true;
    }

    if (defender.character.stance === "defense") {
      if (defender.character.defense >= totalDamage) {
        defender.character.defense -= totalDamage;
      } else {
        const leftover = totalDamage - defender.character.defense;
        defender.character.defense = 0;
        defender.character.stance = "attack";
        defender.character.health -= leftover;
      }
    } else {
      defender.character.health -= totalDamage;
    }

    if (defender.character.health <= 0) {
      defender.character.health = 0;
      defender.character.isDead = true;
    }
  }

  playersCopy[botIndex] = attacker;
  playersCopy[targetIndex] = defender;

  // ✅ Elimination logic
  if (defender.character.isDead) {
    // console.log(`${defender.name} is dead!`);

    // Fetch the latest data from Firestore to avoid stale updates
    const freshSnap = await getDoc(matchRef);
    const freshData = freshSnap.data();
    const currentEliminated = freshData?.eliminated || [];

    const alreadyEliminated = currentEliminated.find(
      (e) => e.id === defender.id
    );

    if (!alreadyEliminated) {
      const eliminatedEntry = {
        name: defender.name,
        id: defender.id,
        character: defender.character.name,
        eliminatedBy: {
          name: attacker.name,
          id: attacker.id,
          character: attacker.character.name,
        },
      };

      const updatedEliminated = [eliminatedEntry, ...currentEliminated];

      await updateDoc(matchRef, {
        eliminated: updatedEliminated,
      });

      //   console.log(`🗑️ Updated Firestore with elimination of ${defender.name}`);
    }
  }

  const move = {
    type: totalDamage === 0 ? "attack - missed" : "attack",
    attacker: attacker.name,
    defender: defender.name,
    damage: totalDamage,
    criticalHit: critical,
    timestamp: Date.now(),
  };

  console.log("👉 playersCopy before stance:", playersCopy);
  let updatedPlayersCopy = stripHandAndDeckFromPlayers(playersCopy);
  console.log("👉 Updated playersCopy after trade:", updatedPlayersCopy);

  await syncMatchData(attacker.id, updatedPlayersCopy, move);

  await delay(500);
};

// export const simulateBotPlayCard = async (
//   roomId,
//   bot,
//   playersCopy,
//   card,
//   syncMatchData,
//   target = bot,
//   matchRef,
//   hands,
//   decks
// ) => {
//   try {
//     const botIndex = playersCopy.findIndex((p) => p.id === bot.id);
//     const targetIndex = playersCopy.findIndex((p) => p.id === target.id);

//     let reCopiedPlayers = [...playersCopy];

//     let acting = { ...bot };
//     let receiver = { ...target };
//     acting.hand = hands[acting.id];
//     acting.deck = decks[acting.id];

//     // === Parse effect logic
//     const { affectedAreas, amount, duration, isAid } = parseCardEffect(card);

//     affectedAreas.forEach((key) => {
//       const area = key.toLowerCase(); // normalize

//       const isInstant = duration === 0;

//       if (isInstant && area !== "attack" && area !== "accuracy") {
//         receiver.character[area] = Number(receiver.character[area]) + amount;
//       } else {
//         if (!receiver.character.buffs[area]) {
//           receiver.character.buffs[area] = [];
//         }

//         const buffObj = {
//           amt: isAid ? amount : -amount,
//           duration,
//           // instant: isInstant,
//         };
//         receiver.character.buffs[area].push(buffObj);
//       }
//     });

//     acting.hand = [...hands[acting.id]].filter((c) => c.id !== card.id);
//     if (acting?.deck?.length > 0) {
//       acting.hand.push(acting.deck.shift());
//     }

//     try {
//       await updateHandAndDeck(roomId, acting.id, acting.hand, acting.deck);
//     } catch (err) {
//       console.error("🚨 Failed to save bot hand/deck:", err);
//     }

//     reCopiedPlayers[botIndex] = acting;
//     reCopiedPlayers[targetIndex] = receiver;

//     const move = {
//       type: "playCard",
//       player: bot.name,
//       card: card,
//       target: target.name,
//       effect: { affectedAreas, amount, duration, isAid },
//       timestamp: Date.now(),
//     };

//     console.log("👉 reCopiedPlayers before stance:", reCopiedPlayers);

//     let updatedPlayersCopy = stripHandAndDeckFromPlayers(reCopiedPlayers);
//     console.log("👉 Updated playersCopy after play card:", updatedPlayersCopy);

//     await syncMatchData(bot.id, updatedPlayersCopy, move);
//     await delay(500);
//   } catch (err) {
//     console.error("❌ simulateBotPlayCard Error:", err);
//   }
// };

export const simulateBotPlayCard = async (
  roomId,
  bot,
  playersCopy,
  card,
  syncMatchData,
  target = bot,
  matchRef,
  hands,
  decks
) => {
  try {
    const botIndex = playersCopy.findIndex((p) => p.id === bot.id);
    const targetIndex = playersCopy.findIndex((p) => p.id === target.id);

    let reCopiedPlayers = [...playersCopy];
    let acting = { ...bot };
    let receiver = { ...target };
    acting.hand = hands[acting.id];
    acting.deck = decks[acting.id];

    if (card.specialty) {
      const result = specialtyCardEffect({
        card,
        actingPlayer: acting,
        targetPlayer: receiver,
        players: reCopiedPlayers,
        hands,
        decks,
        matchRef,
        roomId,
      });

      reCopiedPlayers = result.players;
      hands = result.hands;
      decks = result.decks;

      // Remove the card from bot's hand
      hands[acting.id] = hands[acting.id].filter((c) => c.id !== card.id);

      // Refill hand from deck if needed
      if (decks[acting.id]?.length > 0) {
        hands[acting.id].push(decks[acting.id].shift());
      }

      // Save bot's updated hand/deck
      await updateHandAndDeck(
        roomId,
        acting.id,
        hands[acting.id],
        decks[acting.id]
      );

      // Strip hand/deck for sync
      const cleanPlayers = stripHandAndDeckFromPlayers(reCopiedPlayers);

      const move = {
        type: "playCard",
        player: bot.name,
        card,
        target: target.name,
        timestamp: Date.now(),
      };

      await syncMatchData(bot.id, cleanPlayers, move);
      await delay(500);
      return;
    }

    // === Fallback: normal card logic
    const { affectedAreas, amount, duration, isAid } = parseCardEffect(card);

    affectedAreas.forEach((key) => {
      const area = key.toLowerCase();
      const isInstant = duration === 0;

      if (isInstant && area !== "attack" && area !== "accuracy") {
        receiver.character[area] = Number(receiver.character[area]) + amount;
      } else {
        if (!receiver.character.buffs[area]) {
          receiver.character.buffs[area] = [];
        }

        const buffObj = {
          amt: isAid ? amount : -amount,
          duration,
        };
        receiver.character.buffs[area].push(buffObj);
      }
    });

    // Remove card from bot’s hand
    acting.hand = acting.hand.filter((c) => c.id !== card.id);

    // Refill from deck
    if (acting?.deck?.length > 0) {
      acting.hand.push(acting.deck.shift());
    }

    // Save bot hand/deck
    await updateHandAndDeck(roomId, acting.id, acting.hand, acting.deck);

    // Update players
    reCopiedPlayers[botIndex] = acting;
    reCopiedPlayers[targetIndex] = receiver;

    const move = {
      type: "playCard",
      player: bot.name,
      card,
      target: target.name,
      effect: { affectedAreas, amount, duration, isAid },
      timestamp: Date.now(),
    };

    const updatedPlayersCopy = stripHandAndDeckFromPlayers(reCopiedPlayers);
    await syncMatchData(bot.id, updatedPlayersCopy, move);
    await delay(500);
  } catch (err) {
    console.error("❌ simulateBotPlayCard Error:", err);
  }
};

export const simulateBotTradeCard = async (
  roomId,
  bot,
  target,
  playersCopy,
  card,
  syncMatchData,
  hands,
  decks
) => {
  const botIndex = playersCopy.findIndex((p) => p.id === bot.id);
  const targetIndex = playersCopy.findIndex((p) => p.id === target.id);

  const botCopy = { ...bot };
  let botHand = hands?.[bot.id];
  const targetCopy = { ...target };
  const targetPlayerHand = hands?.[target.id];

  if (botHand.length === 0 || targetPlayerHand.length === 0) {
    console.warn("🛑 Cannot trade — one or both players have no cards.");
    return false; // ❌ trade failed
  }

  const lowestCard = targetPlayerHand.reduce((min, c) =>
    (c.amount ?? 0) < (min.amount ?? 0) ? c : min
  );

  botHand = botHand.filter((c) => c.id !== card.id);
  targetCopy.hand = targetPlayerHand.filter((c) => c.id !== lowestCard.id);

  botHand.push(lowestCard);
  targetCopy.hand.push(card);

  try {
    await Promise.all([
      updateHandAndDeck(roomId, bot.id, botHand, null),
      updateHandAndDeck(roomId, targetCopy.id, targetCopy.hand, null),
    ]);
  } catch (err) {
    console.error("🚨 Failed to save deck/hand during trade:", err);
    return false;
  }

  playersCopy[botIndex] = botCopy;
  playersCopy[targetIndex] = targetCopy;

  const move = {
    type: "tradeCard",
    player: bot.name,
    card: card,
    target: target.name,
    timestamp: Date.now(),
  };

  console.log("👉 playersCopy before stance:", playersCopy);
  let updatedPlayersCopy = stripHandAndDeckFromPlayers(playersCopy);
  console.log("👉 Updated playersCopy after trade:", updatedPlayersCopy);

  await syncMatchData(bot.id, updatedPlayersCopy, move);
  await delay(500);

  return true; // ✅ success
};
